import React from 'react'
import { H2 } from "@blueprintjs/core";

const NoResults = () => {
    return (
        <div className='new-results'>
            <div className="text-center" style={{ marginTop: "15px" }}>
                <H2 id='result'>Unavailable result</H2>
                <p className='margin-bottom-large'>This session does not seem to have any results !</p>
            </div>
        </div>
    )
}

export default NoResults
